module.exports = __webpack_public_path__ + "img/d_Logo2.0a1e98a2.png";